import React from "react";
import ImageIcon from "./ImageIcon";
import PrintIcon from "../../assets/icons/PrintIcon";
import { Tooltip } from "react-tooltip";
const PrintButton = () => {
  return (
    <>
     <Tooltip
                id="print-tooltip"
                style={{
                  backgroundColor: "#ccc",
                  color: "#1e1850",
                  fontWeight: "bold",
                  
                  top: "0px",
                  zIndex: 1000,
                }}
                place="top"
              />
    <button
      data-tooltip-id="print-tooltip"
      data-tooltip-content="Print"
      className="flex gap-2 items-center  dark:bg-primaryLight p-2 rounded-2xl border border-[#6666665C]"
      onClick={() => {
        window.print();
      }}
    >
      <ImageIcon
        className="min-w-[32px]"
        Icon={PrintIcon}
        width={32}
        height={32}
      />
    </button></>
    
  );
};

export default PrintButton;
